import { useContext, useState } from 'react';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { EmptyStateOrderSuccess } from '../../Common/EmptyStates';
import { SectionHelp } from '../../Common/Help/SectionHelp';
import NewsletterCheckoutBanner from '../../Common/Marketing/NewsletterCheckoutBanner';
import { useSearchParams } from 'react-router-dom';
import { forEach } from 'lodash';
import { OrderProductItemModel } from '../../../models/Orders';
import { orderService } from '../../../services/orders';
import { useEffectOnce } from '../../../../../common/hooks/useEffectOnce';

export const CartSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const { customerInfo } = useContext(CustomerInfoContext);
  const [orderId] = useState<number>(Number(searchParams.get('orderId')));

  const trackPurchaseEvent = async (orderId: number) => {
    try {
      const response_op = await orderService.getOrderProducts(orderId);
      if (!response_op.hasErrors) {
        const productsViewInfo = getSlideViewsInfoFromLocalStorage(
          response_op.data,
        );

        if (globalThis.pa) {
          try {
            forEach(productsViewInfo, (item, productId) => {
              globalThis.pa.sendEvent('product.purchase', {
                product_id: Number(productId),
                views: item.views ?? item,
                diff_days: item.diff_days,
                customer_group_id: customerInfo?.customerGroupId,
              });
            });
          } catch (trackingError) {
            console.warn('Tracking blocked or failed:', trackingError);
          }
        }
      }
    } catch (apiError) {
      console.error('Order service error:', apiError);
    }
  };

  const getSlideViewsInfoFromLocalStorage: (
    orderProducts: OrderProductItemModel[],
  ) => Record<number, { views: number; diff_days: number }> = (
    orderProducts: OrderProductItemModel[],
  ) => {
    const viewInfo = JSON.parse(
      localStorage.getItem('slide-view-info') ?? '{}',
    );
    const {
      product = {},
      category = {},
      category_brand = {},
      link = {},
    } = viewInfo;
    const orderProductViewCounts: Record<
      number,
      { views: number; diff_days: number }
    > = {};
    forEach(orderProducts, item => {
      const productId = item.productId;
      let viewCounts = product[productId]?.views ?? product[productId];
      let diffDays = product[productId]?.sd
        ? Math.floor(
            (Date.now() - new Date(product[productId]?.sd).getTime()) /
              (1000 * 60 * 60 * 24),
          )
        : 0;
      forEach(item.categories, categoryId => {
        viewCounts += category[categoryId] ?? 0;
        viewCounts += category_brand[`${categoryId}-${item.brand}`] ?? 0;
      });
      orderProductViewCounts[item.productId] = {
        views: viewCounts,
        diff_days: diffDays,
      };
    });

    forEach(orderProducts, item => {
      const productId = item.productId;
      product[productId] = {
        views: 0,
        sd: new Date(),
      };
      forEach(item.categories, categoryId => {
        category[categoryId] = 0;
        category_brand[`${categoryId}-${item.brand}`] = 0;
      });
    });

    localStorage.setItem(
      'slide-view-info',
      JSON.stringify({
        product,
        category,
        category_brand,
        link,
      }),
    );
    return orderProductViewCounts;
  };

  useEffectOnce(() => {
    if (orderId) {
      trackPurchaseEvent(orderId);
    }
  });

  return (
    <section className="section-main section-full order-success-page">
      <div className="container mb-10">
        <EmptyStateOrderSuccess />
      </div>
      {customerInfo.showNewsletterBanners && !customerInfo.isSavingsUser && (
        <div className="container mb-40">
          <NewsletterCheckoutBanner />
        </div>
      )}
      <SectionHelp />
    </section>
  );
};
